module.exports = __webpack_public_path__ + "static/media/phone_mock_screen.d337204c.svg";